import { emit } from "actions"
import { Buttons, Shared } from "components"
import { discountCodesColumns } from "config/constants"
import { debounce } from "lodash"
import { useCallback, useEffect } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { renderCell } from "utilities"
import "./styles.scss"
import { useTranslation } from "react-i18next"

const DiscountCodes = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    const { discountCampaigns, nextPage, hasNextPage, totalDocs } = useSelector(({ discountCodes }) => discountCodes) || {}

    const fetch = useCallback((payload = {}) => emit({
        action: 'discount/listCampaigns',
        payload,
        startLoading: true,
        stopLoading: true,
    }), [])
    const fetchDebounced = debounce(fetch, 300)

    useEffect(() => { fetch() }, [fetch])


    return <div className="screen-discount-codes-container">
        <div className="screen-discount-codes-inner-container">
            <div className="screen-discount-codes-content">
                <Shared.Table
                    fixedWidth
                    columns={discountCodesColumns}
                    data={discountCampaigns}
                    renderCell={(discountCode, field) => renderCell.discountCodes(discountCode, field, { navigate, t })}
                    handlePagination={() => hasNextPage && fetchDebounced({ pageNumber: nextPage })}
                />
            </div>
            <div className="screen-discount-codes-footer row">
                <div className="row row-stats">
                    <p>{t('discountCodes.count')}: <span>{totalDocs ?? 0}</span> </p>
                </div>
                <div className="row row-buttons">
                    <Buttons.Raised text={t('discountCodes.createDiscountCode')} onClick={() => navigate(`/discount-code/form`)} />
                </div>
            </div>
        </div>
    </div>
}

export default DiscountCodes